import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Particle from "../Particle";

const resumeImage = "/Resume.svg";

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  const scaleStyle = {
    width: width > 786 ? "70%" : "90%",
    maxWidth: "1000px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  };

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Row className="resume d-flex justify-content-center">
          <img
            src={resumeImage}
            alt="Resume"
            style={scaleStyle}
          />
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
